import React from "react";
import { FaUser, FaUsers } from "react-icons/fa";
import { IoMdSettings } from "react-icons/io";
import { FaLocationDot, FaMapLocationDot } from "react-icons/fa6";

// show roles: "provider" | "nurse" | "nurse_admin" (nurse with is_facility_admin)
export const settings_sidebar_tabs = [
  {
    id: 1,
    title: "User Profile",
    slug: "user_profile",
    icon: <FaUser size={20} />,
    show: ["nurse"],
  },
  {
    id: 2,
    title: "Report a Problem",
    slug: "report_a_problem",
    icon: <IoMdSettings size={22} />,
    show: ["provider"],
  },
  {
    id: 3,
    title: "Locations",
    slug: "locations",
    icon: <FaLocationDot size={20} />,
    show: ["provider","nurse_admin"],
  },
  {
    id: 4,
    title: "Facility Staff",
    slug: "facility_staff",
    icon: <FaUsers size={20} />,
    show: ["provider"],
  },
  {
    id: 5,
    title: "Facility Location Groups",
    slug: "facility_location_groups",
    icon: <FaMapLocationDot size={20} />,
    show: ["provider"],
  },
];
